import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Asset from 'umg-ember-backend/components/record-explorer/for/asset/index';
import Button from 'umg-ember-backend/components/ui/button/index';
import Form from 'umg-ember-backend/components/ui/form';
import Modal from 'umg-ember-backend/components/ui/modal/index';
import { imageUrl } from 'umg-ember-backend/helpers/image-url';
import storeOnRoute from 'umg-ember-backend/utils/decorators/store-on-route';
import { getRecordType } from 'umg-ember-backend/utils/get-record-type';

export default class RecordDetailFormsHtmlComponet extends Component {
  // Services
  @service breadcrumb;

  // Defaults
  @tracked filters = {};
  @storeOnRoute('args.fieldId') isRecordListOpen = false;
  @storeOnRoute('args.fieldId') scrollPositionAssign;

  // Functions
  assignRecords = (records) => {
    this.toggleRecordList();

    let content = this.args.model.html ?? '';

    records.forEach((record) => {
      if (record.isImage) {
        content += `\n${imageUrl([record, '{ratio}/{width}'])}`;
      } else if (record.isVideo || record.isAudio) {
        content += `\n${record.get('videoUrl')}`;
      }
    });

    this.args.model.html = content;
  };

  toggleRecordList = () => {
    this.isRecordListOpen = !this.isRecordListOpen;
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1'>
          <form.fieldset @titleKey='elements' as |fieldset|>
            <fieldset.field @property='headline' />

            <fieldset.field
              @property='html'
              @type='code-editor'
              @codeFormat='html'
            />

            <Button
              @label={{t 'record_detail.forms.html.assign_asset'}}
              {{on 'click' this.toggleRecordList}}
            />
          </form.fieldset>
        </div>
      </div>
    </Form>

    <Form @model={{@mlp}} @showErrors={{@showErrors}} as |form|>
      <form.fieldset @titleKey='customCode' as |fieldset|>
        <fieldset.field
          @property='options.customCSS'
          @type='code-editor'
          @codeFormat='css'
        />
        <fieldset.field
          @property='options.customHeader'
          @type='code-editor'
          @codeFormat='html'
        />
        <fieldset.field
          @property='options.customJs'
          @type='code-editor'
          @codeFormat='javascript'
        />

        {{yield}}
      </form.fieldset>
    </Form>

    <Modal
      @onClose={{this.toggleRecordList}}
      @dataDependencies={{this.isRecordListOpen}}
    >
      <Asset
        @filter={{this.filters}}
        @recordType='asset'
        @onAssignRelation={{this.assignRecords}}
        @onBodyScroll={{fn (mut this.scrollPositionAssign)}}
        @parentRecordType={{getRecordType @model}}
        @relationType='hasMany'
        @scrollPosition={{this.scrollPositionAssign}}
      />
    </Modal>
  </template>
}
